import { Alert, Snackbar } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPGState } from "../productGroupSetupSlice";

const alertFontSize = "15px";

export default function EditMessage() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const { editMessage, editMessageSeverity, editMessageOpen } = pgState;
	const dispatch = useDispatch();
	const handleCloseSnackbar = () => {
		dispatch(setPGState("editMessageOpen", false));
		dispatch(setPGState("editMessage", ""));
		dispatch(setPGState("editMessageSeverity", ""));
	};

	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={editMessageOpen}
			autoHideDuration={5000}
			onClose={handleCloseSnackbar}
		>
			<Alert
				onClose={handleCloseSnackbar}
				severity={editMessageSeverity}
				sx={{ width: "100%", fontSize: alertFontSize }}
			>
				{editMessage}
			</Alert>
		</Snackbar>
	);
}
